// UUID validation for ids read out of localStorage before they're sent to the
// API. A malformed USER_ID (e.g. a truncated id missing a leading character)
// is not a valid Postgres uuid: it 500s `getUserById` on the backend and, via
// the locale interceptors, gets re-sent on effectively every request — a
// self-inflicted request + DB-alert storm. Treating a malformed id as "no id"
// stops the garbage at the source.

// Lenient 8-4-4-4-12 hex shape — matches any real stored uuid without enforcing
// RFC version/variant nibbles (so we never reject a legitimate id).
export const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUuid(value) {
  return typeof value === "string" && UUID_RE.test(value);
}

// The stored USER_ID, but only if it's a well-formed uuid. Empty/sentinel values
// and malformed ids both return null so callers never attach them to a request.
export function getValidUserId() {
  const raw = localStorage.getItem("USER_ID");
  if (!raw || raw === "undefined" || raw === "null") return null;
  return isValidUuid(raw) ? raw : null;
}

// One-time boot cleanup: if the persisted USER_ID is malformed it can never
// resolve to a real user — drop it so the app falls back to a clean logged-out
// state (and a fresh login) instead of endlessly re-sending a poisoned id.
export function sanitizeStoredUserId() {
  const raw = localStorage.getItem("USER_ID");
  if (raw && raw !== "undefined" && raw !== "null" && !isValidUuid(raw)) {
    localStorage.removeItem("USER_ID");
    return true;
  }
  return false;
}
